import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
let KickoutService = class KickoutService {
    constructor(kickoutApi) {
        this.kickoutApi = kickoutApi;
        this.getKickoutrecords = this.kickoutApi.getKickoutrecords;
    }
};
KickoutService = __decorate([
    injectable(),
    __param(0, inject(Symbols.KickoutApi)),
    __metadata("design:paramtypes", [Object])
], KickoutService);
export { KickoutService };
